import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const PAY_API = `${BASE}/api/payments`;

const err = (e, f) => new Error(e?.response?.data?.message || e?.response?.data?.detail || f);

export const getPayConfig = async () => (await axios.get(`${PAY_API}/config`)).data;
export const getPurposes = async () => (await axios.get(`${PAY_API}/purposes`)).data.purposes;

export const createOrder = async (payload) => {
  try { return (await axios.post(`${PAY_API}/create-order`, payload)).data; }
  catch (e) { throw err(e, "Could not initiate payment."); }
};
export const verifyPayment = async (payload) => {
  try { return (await axios.post(`${PAY_API}/verify`, payload)).data; }
  catch (e) { throw err(e, "Payment verification failed."); }
};
export const markFailed = async (orderId, reason) => {
  try { return (await axios.post(`${PAY_API}/failed`, { razorpay_order_id: orderId, reason })).data; }
  catch (e) { return null; }
};
export const getPaymentStatus = async (ref) => (await axios.get(`${PAY_API}/status/${ref}`)).data;
export const getHistory = async (email, mobile) => {
  try { return (await axios.get(`${PAY_API}/history`, { params: { email, mobile } })).data.items; }
  catch (e) { throw err(e, "Could not load payment history."); }
};
export const receiptUrl = (ref) => `${PAY_API}/receipt/${ref}.pdf`;

let scriptPromise = null;
export const loadRazorpayScript = () => {
  if (window.Razorpay) return Promise.resolve(true);
  if (scriptPromise) return scriptPromise;
  scriptPromise = new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => reject(new Error("Failed to load Razorpay checkout."));
    document.body.appendChild(s);
  });
  return scriptPromise;
};

export const isValidIndianMobile = (v) => /^[6-9]\d{9}$/.test((v || "").replace(/\D/g, "").replace(/^91/, ""));
export const isValidEmail = (v) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test((v || "").trim());
